
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin-portal/onboarding/knowledge-base",
      function () {
        return require("private-next-pages/admin-portal/onboarding/knowledge-base.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin-portal/onboarding/knowledge-base"])
      });
    }
  